import React, { Component, PropTypes } from 'react';
import AppPage from 'components/AppPage';
import RulerBar from 'components/RulerBar';
import AcceptGift from './AcceptGift';
import { AuthStore, InvitationStore } from 'stores';
import { mixin, RefluxMixin } from 'Util';
import { InvitationActions } from 'actions';
import Loader from 'components/Material/Loader';

export default class AcceptGiftContainer extends mixin(RefluxMixin, Component) {
  static propTypes = {
    params: PropTypes.object
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  listenToStores() {
    this.listenToStore(AuthStore, 'auth');
    this.listenToStore(InvitationStore, 'invitation');
  }

  componentDidMount() {
    const { giftCode } = this.props.params;
    if (giftCode) {
      InvitationActions.checkGiftCode(giftCode);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      nextState.auth.loggedIn !== this.state.auth.loggedIn ||
      nextState.invitation !== this.state.invitation
    );
  }

  render() {
    const { giftCode } = this.props.params;
    const { invitation } = this.state.invitation;
    const {
      usedByMe,
      error,
      email,
      expired,
      accepted,
      accepting,
      used,
      owner,
      course
    } = invitation;
    const { loggedIn } = this.state.auth;
    return (
      <AcceptGift
        giftCode={giftCode}
        used={used}
        accepting={accepting}
        accepted={accepted || usedByMe}
        usedByMe={usedByMe}
        expired={expired}
        loggedIn={loggedIn}
        email={email}
        owner={owner}
        course={course}
        error={error}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Route/Gift/AcceptGiftContainer.js